import { memo } from 'react'
import { useActions, useCanRedo, useTranslation } from '../../hooks'
import { Button, kbdStr } from '../primitives'

export const RedoButton = memo(function RedoButton() {
	const msg = useTranslation()
	const canRedo = useCanRedo()
	const actions = useActions()

	const redo = actions['redo']

	return (
		<Button
			data-wd="main.redo"
			icon={redo.icon}
			title={`${msg(redo.label!)} ${kbdStr(redo.kbd!)}`}
			disabled={!canRedo}
			onClick={redo.onSelect}
			smallIcon
		/>
	)
})
